var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 5.72327C10.7 6.38262 10.4016 7.20297 9.89026 8.10302C9.38574 8.99108 8.70631 9.90129 8.01645 10.7262C7.32815 11.5492 6.63845 12.2768 6.12011 12.799C5.91627 13.0044 5.73936 13.1777 5.6 13.312C5.46064 13.1777 5.28373 13.0044 5.07989 12.799C4.56155 12.2768 3.87185 11.5492 3.18355 10.7262C2.49369 9.90129 1.81426 8.99108 1.30974 8.10302C0.798411 7.20297 0.5 6.38262 0.5 5.72327C0.5 2.82822 2.79356 0.5 5.6 0.5C8.40644 0.5 10.7 2.82822 10.7 5.72327Z",
    stroke: "#787395"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.59909,
    cy: 5.60007,
    r: 1.86667,
    fill: "#787395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.08a35b11.svg";
export { ForwardRef as ReactComponent };